export default {
  methods: {
    _calculationsRequest(url, params, onSuccess, onError) {
      this.request({
        url: this.endpoint(url),
        method: "get",
        params,
        success: data => onSuccess(data),
        error: err => {
          if (onError) onError(err)
          else this.handleError(err, {})
        }
      })
    },

    getPartnerCalculationsList(params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/calculations/`, params, onSuccess, onError)
    },

    getPartnerCalculationDetail(productId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/calculations/${productId}/`, params, onSuccess, onError)
    },

    getPartnerCalculationsDaily(params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/calculations/daily/`, params, onSuccess, onError)
    },

    getPartnerCalculationsSettlement(params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/calculations/settlement/`, params, onSuccess, onError)
    },

    getPartnerCalculationsReturns(params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/calculations/returns/`, params, onSuccess, onError)
    },

    getPartnerCalculationsCostExposure(params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/calculations/cost-exposure/`, params, onSuccess, onError)
    },

    // --- نسخه‌ی مدیر کل: همون گزارش‌ها ولی با partnerId مشخص، برای صفحه‌ی «گزارش‌گیری شریک» ---

    getAdminPartnerCalculationsList(partnerId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/calculations/`, params, onSuccess, onError)
    },

    getAdminPartnerCalculationDetail(partnerId, productId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/calculations/${productId}/`, params, onSuccess, onError)
    },

    getAdminPartnerCalculationsDaily(partnerId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/calculations/daily/`, params, onSuccess, onError)
    },

    getAdminPartnerCalculationsSettlement(partnerId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/calculations/settlement/`, params, onSuccess, onError)
    },

    getAdminPartnerCalculationsReturns(partnerId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/calculations/returns/`, params, onSuccess, onError)
    },

    getAdminPartnerCalculationsCostExposure(partnerId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/calculations/cost-exposure/`, params, onSuccess, onError)
    },

    getAdminPartnerPackingDiscrepancy(partnerId, params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/partners/${partnerId}/packing-discrepancy/`, params, onSuccess, onError)
    },

    // --- جابه‌جایی مالکیت فروش بین شریک‌ها (فقط مدیر کل) ---

    searchSalesReassignment(params, onSuccess, onError) {
      this._calculationsRequest(`partner-stock/dashboard/sales-reassignment/search/`, params, onSuccess, onError)
    },

    applySalesReassignment(payload, onSuccess, onError) {
      this.request({
        url: this.endpoint('partner-stock/dashboard/sales-reassignment/apply/'),
        method: 'post',
        data: payload,
        success: data => onSuccess(data),
        error: err => {
          if (onError) onError(err)
          else this.handleError(err, {})
        }
      })
    },
  },
}
